import { Component } from '@angular/core';
import { WguOauth2Service } from '@wgu-edu/oauth2';
import { AUTH_CLIENT_KEY } from 'src/app/models/constants';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.css'],
    imports: [MatIcon]
})
export class FooterComponent {

  year: number = new Date().getFullYear();

  constructor(
    private oauth: WguOauth2Service,
  ) { }

  logout() {
    sessionStorage.clear();
    this.oauth.redirectToLogout();
  }
}
